/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerFindAllQueryResponse, TrialsControllerFindAllQueryParams, TrialsControllerFindAll401, TrialsControllerFindAll403 } from "../../models/trialsController/TrialsControllerFindAll";

function getTrialsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/trials` as const }  
  return res
}

/**
 * @summary List trials (paginated)
 * {@link /api/v1/trials}
 */
export async function trialsControllerFindAll(params?: TrialsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrialsControllerFindAllQueryResponse, ResponseErrorConfig<TrialsControllerFindAll401 | TrialsControllerFindAll403>, unknown>({ method : "GET", url : getTrialsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}